export default {
    nombre: '',
    slug: 'fuengirola',
    prodActiveCat: {
        'loading': false,
        'productos': '',
        'opciones': '',
    },
    loadingRest: false,
    categorias: [],
    caracteristicas: null,
    cocinas: [],
    impuestos: [],
    descuentos: [],
    categoriasBartolome: [],
    horarios: [],
    activeRest: null,
    listadoRestaurantes: [],                //Se usa en Recoger
    listadoNegocios: [],                    //Se usa en Recoger
    allProductos: [],
    AllProductosSinCategoria: [],
    allProductosBartolome: [],
    categoriasFiltradas: [],
    restaurantesPosibles: []                //Comprobar que este state no se pueda unir a listadoRestaurantes
}